
$models.folders = {
	
	getItem : function($folderid, $callback, $errorHandler) {
		if (!$errorHandler) { $errorHandler = 'Unable to load the requested folder'; }
		$models.all.getDataFromAPI('folders/'+$folderid+'.json', {}, $callback, $errorHandler);
	},
	
	getList : function($params, $callback) {
		if ($models.folders.currentGetListAjaxRequest) {
			$models.folders.currentGetListAjaxRequest.abort();
		}
		$models.folders.currentGetListAjaxRequest = $models.all.getDataFromAPI('folders.json', $params, $callback, 'Unable to load the list of folders');
	},
	
	getListWithOffset : function($params, $callback) {
		$params = ($params || {});
		if (!$params.max_results) {
			$params.max_results = $views.foldermanager.maxResultsPerPage;
		}
		if ($controllers.foldermanager.currentFoldersListOffset > 0) {
			$params['offset'] = $controllers.foldermanager.currentFoldersListOffset;
		}
		$models.folders.getList($params, $callback);
	},
	
	getSize : function($callback) {
		$models.all.getDataFromAPI('folders/count.json', '', $callback, 'Unable to retrieve number of folders within your team');
	},
	
	getNextReference : function($callback) {
		$models.all.getDataFromAPI('last_folder_reference.json', '', $callback, 'Unable to get next folder reference');
	},
	
	setItem : function($folderid, $reference, $name, $description, $type, $status, $teamid, $custom_permissions, $callback) {
		
		var $data = {folder: {reference: jQuery.trim($reference), name: jQuery.trim($name), description: $description, folder_type_id: $type, folder_status_id: $status, custom_permissions: $custom_permissions}};
		if ($teamid && ($folderid == 0)) {
			$data['team_id'] = $teamid;
		}
		
		if ($folderid > 0) {
			$models.all.getDataFromAPI('folders/'+$folderid+'.json', $data, $callback, 'An error occurred whilst saving changes to the folder', 'PUT');
		} else {
			$models.all.getDataFromAPI('folders.json', $data, $callback, 'An error occurred whilst creating the folder', 'POST');
		}
		
		$cached.folders.dataHasChanged();
		
	},
	
	deleteItem : function($folderid, $callback) {
		$models.all.getDataFromAPI('folders/'+$folderid+'.json', {}, $callback, 'An error occurred whilst deleting the folder', 'DELETE');
		$cached.folders.dataHasChanged();
	},
	
	archiveItem : function($folderid, $callback) {
		$models.all.getDataFromAPI('folders/archive.json?folder_ids='+$folderid, {}, $callback, 'An error occurred whilst archiving the folder');
	},
	
	isEditable : function($folder) {
		var $folderIsEditable = false;
		if ($models.login.hasAdminPrivileges() && !$folder.team) {
			return false;
		}
		if ($models.login.hasAdminPrivileges() && ($models.login.getTeamid() == $folder.team.id)) {
			$folderIsEditable = true;
		}
		if ($folder.owner_email == $models.login.getUsername()) {
			$folderIsEditable = true;
		}
		return $folderIsEditable;
	},
	
	getListPerms : function($params, $callback) {
		$models.all.getDataFromAPI('permissions.json', $params, $callback, 'Unable to retrieve permissions list.  You might not have permission to do so.');
	},
	
	translatePermsValue : function($value) {
		if ($value == 3) {
			return 'Read & contribute';
		} else if ($value == 2) {
			return 'Contribute only';
		} else if ($value == 1) {
			return 'Read only';
		} else {
			return 'Legacy permissions, or custom permissions';
		}
	},
	
	decodePermsSet : function($perms, $filterByEmail) {
		
		var $miniPerms = {decodedVal:-1, decodedLabel:$models.folders.translatePermsValue(-1)};
		jQuery.each($perms, function($key, $perm) {
			var $type = $perm.permission_type;
			var $val = $perm.value;
			if (!$filterByEmail || ($filterByEmail && ($filterByEmail == $perm.user_email))) {
				$miniPerms[$type] = $val;
			}
		});
		
		if (
		($miniPerms.read_and_contribute == false) &&
		($miniPerms.read_only == true)
		) {
			$miniPerms.decodedVal = 1;
			$miniPerms.decodedLabel = $models.folders.translatePermsValue(1);
		}
		
		if ($miniPerms.read_and_contribute == true) {
			$miniPerms.decodedVal = 3;
			$miniPerms.decodedLabel = $models.folders.translatePermsValue(3);
		}
		
		return $miniPerms;
		
	},
	
	encodePermsSet : function($email, $val) {
		
		if ($val == 3) {
			
			var $fullPerms = [
				{user_email: $email, permission_type: 'read_and_contribute', value: true},
				{user_email: $email, permission_type: 'read_only', value: false}
			];
			
		} else if ($val == 2) {
			
			var $fullPerms = [
				{user_email: $email, permission_type: 'read_and_contribute', value: false},
				{user_email: $email, permission_type: 'read_only', value: false}
			];
			
		} else if ($val == 1) {
			
			var $fullPerms = [
				{user_email: $email, permission_type: 'read_and_contribute', value: false},
				{user_email: $email, permission_type: 'read_only', value: true}
			];
			
		} else {
			
			var $fullPerms = [
				{user_email: $email, permission_type: 'read_and_contribute', value: false},
				{user_email: $email, permission_type: 'read_only', value: false}
			];
			
		}
		
		return $fullPerms;
		
	},
	
	isAjaxRequestInProgress : function() {
		if (!$models.folders.currentGetListAjaxRequest) { return false; }
		if ($models.folders.currentGetListAjaxRequest.status > 100) { return false; }
		return true;
	}
	
};

$models.folderpermissions = {
	
	folderId : 0,
	cachedUsers : 0,
	
	getItem : function($id, $callback) {
		
	},
	
	getList : function($params, $callback) {
		if ($models.folderpermissions.currentGetListAjaxRequest) {
			$models.folderpermissions.currentGetListAjaxRequest.abort();
		}
		$models.folderpermissions.currentGetListAjaxRequest = $models.all.getDataFromAPI('folders/'+$models.folderpermissions.folderid+'/permissions.json', '', function($perms) {
			$models.folderpermissions.getCachedTeamUsers(function($team_users) {
				$controllers.foldermanager.cachedFolderPerms = $perms.permissions;
				$perms.users = [];
				var $i = 0;
				var $user_emails = {};
				jQuery.each($perms.permissions, function($key, $perms_user_perm) {
	//				$i = $views.foldermanager.renderFolderPermForUser($i, $perms_user_perm);
					var $email = $perms_user_perm.user_email;
					$user_emails[$email] = $email;
				});
				jQuery.each($user_emails, function($key, $user_email) {
					var $thisUserPerms = $models.folders.decodePermsSet($perms.permissions, $user_email);
					var $thisUserAccount = {};
					jQuery.each($team_users.users, function($key, $team_user) {
						if ($team_user.email == $user_email) {
							$thisUserAccount = $team_user;
							return true;
						}
					});
					$perms.users.push( { id: $soupmail.string.stringHtmlAttributeSafe($user_email), email: $user_email, permissions: $thisUserPerms, user: $thisUserAccount } );
				});
				$callback($perms);
			});
		}, function($responseText) {
			if ($responseText.error && ($responseText.error == 'You cannot get permissions for a folder outside of your own team.')) {
				jQuery('.manage-folder-list-item.view .sharing ul').html('<li style="width:880px;">This folder is owned by '+jQuery('.manage-folder-list-item.view .owner').text()+' and therefore you are not able to view permissions.</li>');
			} else {
				$soupmail.notification.error('Unable to retrieve list of permissions for this folder.', $responseText);
			}
		});
	},
	
	getListWithOffset : function($params, $callback) {
		$params = ($params || {});
		$models.folderpermissions.getList($params, $callback);
	},
	
	getSize : function($callback) {
		$models.folderpermissions.getList({}, function($data) {
			$callback($data.length);
		});
	},
	
	setItem : function($data, $callback) {
		$models.all.getDataFromAPI('folders/'+$models.folderpermissions.folderid+'/permissions.json', $data, $callback, 'An error occurred whilst saving custom folder permissions', 'PUT', 'generic', 'false', 'application/json');
	},
	
	deleteItem : function($ids, $callback) {
		$models.all.getDataFromAPI('folders/'+$models.folderpermissions.folderid+'/permissions.json', {ids: $ids}, $callback, 'Unable to remove user permissions from folder', 'DELETE');
	},
	
	isAjaxRequestInProgress : function() {
		if (!$models.folderpermissions.currentGetListAjaxRequest) { return false; }
		if ($models.folderpermissions.currentGetListAjaxRequest.status > 100) { return false; }
		return true;
	},
	
	getCachedTeamUsers : function($callback) {
		if ($models.folderpermissions.cachedUsers) {
			$callback($models.folderpermissions.cachedUsers);
		} else {
			$models.users.getList({max_results: 1000}, function($data) {
				$models.folderpermissions.cachedUsers = $data;
				$callback($models.folderpermissions.cachedUsers);
			});
		}
		return $models.folderpermissions.cachedUsers;
	},
	
	// CAUTION : make sure that $models.folderpermissions.cachedUsers has been initialised with data, before calling this function!!!
	hasPermissionsWithinMyTeam : function($user_email) {
		var $team_users = $models.folderpermissions.getCachedTeamUsers(function() {});
		var $result = false;
		jQuery.each($team_users.users, function($key, $team_user) {
			if ($team_user.email == $user_email) {
				$result = true;
				return; // optimisation
			}
		});
		return $result;
	},
	
	// CAUTION : make sure that $controllers.foldermanager.cachedFolderPerms has been initialised with data, before calling this function!!!
	hasPermissionsWithinCurrentFolder : function($user_email) {
		var $folder_perms = $controllers.foldermanager.cachedFolderPerms;
		var $result = false;
		jQuery.each($folder_perms, function($key, $specific_perm) {
			if ($specific_perm.user_email == $user_email) {
				$result = true;
				return; // optimisation
			}
		});
		return $result;
	}
	
};



// WEBPACK FOOTER //
// ./src/js/models/folders.js